import { Box } from "@mui/material";
import React from "react";
import useResponsive from "../../hooks/useResponsive";
import { getAppName } from "../../utils/commonMethods";
import { getTenantConfig } from "../../tenantConfig";

export type IAppLogoContainerProps = {};

const AppLogoContainer: React.FC<IAppLogoContainerProps> = ({ }) => {
  const { isMobile } = useResponsive();
  const appName = getAppName();

  const { src: logo, alt: logoAlt } = getTenantConfig(appName).logoLogin;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        width: isMobile ? "80%" : "40%",
        mt: isMobile ? "78px" : "0px",
      }}
    >
      <img
        src={logo}
        alt={logoAlt}
        style={{ width: "100%", }}
      />
    </Box>
  );
};

export default AppLogoContainer;
